import { render, staticRenderFns } from "./newDeliveryPoints.vue?vue&type=template&id=4f1f0bfa&"
import script from "./newDeliveryPoints.vue?vue&type=script&lang=js&"
export * from "./newDeliveryPoints.vue?vue&type=script&lang=js&"
import style0 from "./newDeliveryPoints.vue?vue&type=style&index=0&id=4f1f0bfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports